export default "__VITE_ASSET__Hkrbn24d__"